import { render, staticRenderFns } from "./addMultiProject.vue?vue&type=template&id=b6c1e77e"
import script from "./addMultiProject.vue?vue&type=script&lang=js"
export * from "./addMultiProject.vue?vue&type=script&lang=js"
import style0 from "./addMultiProject.vue?vue&type=style&index=0&id=b6c1e77e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports